var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',[_c('b-badge',{staticClass:"bg-blue"},[_c('i',{staticClass:"fa fa-file mr-2"}),_vm._v(" Form A23 ")])],1)],1),_c('b-row',[_c('b-col',[_vm._v(" "+_vm._s(_vm.data)+" ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }